class Ajax {
  constructor(url, params) {
    return new Promise((resolve, reject) => {
      let http = new XMLHttpRequest();
      if (!http) {
        console.error('Cannot create an XMLHTTP instance');
      }
      http.onreadystatechange = () => {
        if (http.readyState === http.DONE) {
          if (http.status === 200) {
            try {
              resolve(JSON.parse(http.responseText));
            } catch (err) { resolve(http.responseText); }
          } else {
            reject({error: http.statusText});
          }
        }
      }
      http.open('POST', url);
      http.send(params);
    });
  }
}

export default Ajax;



// WEBPACK FOOTER //
// ./scripts/util/Ajax.js